
import React from 'react';
import './Apply_Now_Btn.css';

const Apply_Now_Btn = ({ text, onClick, className = "", ...props }) => {

  
  return (
    <button 
      className={`custom_btn_animated btn-blue ${className}`} 
      onClick={onClick}
      {...props}
    >
      <p className="btn_text_container">
        <span className="btn_text_initial">Apply Now</span>
        <span className="btn_text_hover" >Filling Fast!!!</span>
      </p>
    </button>
  );
};

export default Apply_Now_Btn;